import React from 'react';
import { formatDatetime } from '../lib/recoveryRolloutFormatters';

const RecoveryModeHistoryPanel = ({ rows = [] }) => {
  const items = Array.isArray(rows) ? rows : [];

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="mb-3 text-sm font-semibold text-slate-100">Riwayat Aksi Rollout</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs text-slate-200">
          <thead className="bg-slate-950/80 text-[11px] uppercase tracking-wide text-slate-400">
            <tr>
              <th className="px-3 py-2 text-left">Waktu</th>
              <th className="px-3 py-2 text-left">From</th>
              <th className="px-3 py-2 text-left">To</th>
              <th className="px-3 py-2 text-left">Result</th>
              <th className="px-3 py-2 text-left">Requested By</th>
              <th className="px-3 py-2 text-left">Note</th>
            </tr>
          </thead>
          <tbody>
            {items.length ? items.map((row) => (
              <tr key={row.id} className="border-t border-slate-800">
                <td className="px-3 py-2">{formatDatetime(row.timestamp)}</td>
                <td className="px-3 py-2">{row.previousMode || '-'}</td>
                <td className="px-3 py-2">{row.targetMode || '-'}</td>
                <td className="px-3 py-2">{row.allowed ? 'ALLOWED' : 'BLOCKED'}</td>
                <td className="px-3 py-2">{row.requestedBy || '-'}</td>
                <td className="px-3 py-2">{row.note || '-'}</td>
              </tr>
            )) : (
              <tr>
                <td className="px-3 py-3 text-slate-400" colSpan={6}>Belum ada riwayat aksi mode pada sesi ini.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default RecoveryModeHistoryPanel;
